import CaretDownOutlined from '@ant-design/icons/CaretDownOutlined';
import { ConfigProvider, Select, theme, SelectProps } from 'antd';

import { memo, useRef, ReactNode } from 'react';

const Selection = ({
  children,
  onChange,
  ...rest
}: SelectProps & {
  children?: ReactNode[],
  onChange?: (value: any) => void
}): JSX.Element => {
  const elementRef = useRef();

  const handleChange = (value) => {
    onChange(value);
    if (elementRef.current) {
      elementRef.current.blur();
    }
  };

  return (
    <ConfigProvider
      theme={{
        algorithm: theme.darkAlgorithm,
        token: {
          fontSize: 12,
          borderRadiusSM: 2,
          borderRadiusLG: 2,
          borderRadius: 2,
          colorPrimary: '#39C2D7',
          colorPrimaryHover: '#2799b0',
          colorText: '#fff',
          colorBgBase: '#172126',
          colorBgContainer: 'transparent',
          colorBorder: '#647a87',
          controlItemBgActiveDisabled: '#2C4654',
          controlItemBgActive: '#2C4654',
          controlOutlineWidth: 0,
          colorBgElevated: '#1F313B',
        },
        components: {
          Menu: {
            colorItemBg: 'transparent',
            colorItemBgSelected: '#2c5166',
          },
        },
      }}
    >
      <Select
        size="small"
        ref={elementRef}
        onChange={handleChange}
        menuItemSelectedIcon={null}
        suffixIcon={<CaretDownOutlined className="text-sm" />}
        style={{ width: 80, background: 'transparent' }}
        {...rest}
      >
        {children}
      </Select>
    </ConfigProvider>
  );
};

export default memo(Selection);
